import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { Link as ReactRouterLink } from "react-router-dom";
import { useOrganization } from "@core/organization";
import { injectOrganizationId } from "../utilities/injectOrganizationId.js";
// data-remove-listener attribute disables the LinkHandler in app package
export var Link = /*#__PURE__*/ forwardRef(function(_param, ref) {
    var to = _param.to, props = _object_without_properties(_param, [
        "to"
    ]);
    var _$ref = useOrganization(), orgId = _$ref.id;
    return /*#__PURE__*/ _jsx(ReactRouterLink, _object_spread_props(_object_spread({
        ref: ref
    }, props), {
        to: injectOrganizationId(to, orgId),
        "data-remove-listener": true
    }));
});

//# sourceMappingURL=Link.js.map